import {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import Moment from "react-moment";
import {useDispatch, useSelector} from "react-redux";
import {NavLink, useLocation, useNavigate} from "react-router-dom";

import {MODE} from "../../gitIgnore/appMode";
import ArrowDown from "../../images/icons/arrowDown.png";
import ArrowUp from "../../images/icons/arrowUp.png";
// import {MODE} from "../../gitIgnore/appMode";
import logoutPng from "../../images/icons/logout.png";
import {logout} from "../../slices/UserSlice";
import ToolTip from "../../utilities/ToolTip";
import DevITButton, {IT_MANAGERS_IDS} from "../DevIT/DevITButton";

import logo from "./src/Logo.png";

import "./src/NavBar.scss";

const NavBar = () => {
  const {t, i18n} = useTranslation();

  let activeStyle = {
    fontWeight: 600,
  };
  // const { token } = useSelector(state => state.user);

  const location = useLocation();

  const {token, user} = useSelector(state => state.user);
  const dispatch = useDispatch();

  const isITManager = IT_MANAGERS_IDS.includes(user?.userId);

  useEffect(() => {
    const routeTitles = {
      "/ba3a/warehouse/kits": t("kit reg"),
      "/ba3a/warehouse/samples": t("sapmle reg"),
      "/ba3a/warehouse/transferList/kits": t("kits"),
      "/ba3a/warehouse/transferList/samples": t("samples"),
      "/ba3a/warehousesettings/guides": t("guides"),
      "/ba3a/warehousesettings/deadlines": t("Deadlines"),
      "/ba3a/warehousesettings/users": t("Users"),
      "/ba3a/report": t("report"),
      "/ba3a/references/tasksList": t("Tasks list"),
    };

    const matchedRoute = Object.keys(routeTitles).find(
      route => location.pathname === route || location.pathname.startsWith(`${route}/`),
    );
    const fallbackTitle = location.pathname.split("/").filter(Boolean).pop();
    const currentTitle = matchedRoute ? routeTitles[matchedRoute] : fallbackTitle;

    document.title = `${currentTitle} / ${MODE}`;
  }, [location.pathname, t]);

  const currentLang = (i18n.language || "en").toLowerCase();
  const isUa = currentLang.startsWith("uk");

  const handleLangToggle = () => {
    i18n.changeLanguage(isUa ? "en" : "uk");
  };

  return (
    <div className="navbar">
      {/* <div className="garland" /> */}
      <div className="navbar__container">
        <NavLink end to="/ba3a/warehouse/kits" style={({isActive}) => (isActive ? activeStyle : undefined)}>
          <ToolTip title="Go to Start Page" bottom>
            <div className="navbar__logo">
              <img alt="" src={logo} draggable="false" />
              <h1>ERP ’ba3a’ - {MODE}</h1>
            </div>
          </ToolTip>
        </NavLink>
        {token && (
          <nav className="navbar__top_navigation row jcsb fGrow ml5x mr2x">
            <ul className="fc gap mra mla nowrap">
              {/* <NavItem name="ba3a" disabled> */}
              {/* <MyLink to="/ba3a/admin/addPerson" name={t("Person")} />
                <AccessBoundary>
                  <MyLink to="/ba3a/admin/registr" name={t("User")} />
                </AccessBoundary>
                <MyLink to="/xx" name={t("Designer")} />
                <MyLink to="/ba3a/admin/addClient" name={t("Client")} /> */}
              {/* </NavItem> */}

              {/* <NavItem name={t("PROJECT")} disabled> */}
              {/* <MyLink to="/ba3a/project" name={t("Project")} /> */}
              {/* </NavItem> */}

              {/* <NavItem name={t("CO")} disabled> */}
              {/* <MyLink to="/ba3a/kp" name={t("CO")} />
                <MyLink to="/vdvd" name={t("CO album")} />
                <MyLink to="/vdvd" name={t("CO templates")} />
                <MyLink to="/vdvd" name={t("CO register")} />
                <MyLink to="/ba3a/kp/control" name={t("Control PF")} />
                <MyLink to="/vdvd" name={t("Archive PF")} /> */}
              {/* </NavItem> */}
              {/* <NavItem name="SKU" disabled> */}
              {/* <MyLink to="/ba3a/sku" name="SKU" /> */}
              {/* </NavItem> */}
              {/* <NavItem name={t("FEA")} disabled> */}
              {/* <MyLink to="/ba3a/ved/sku" name="SKU" />
                <MyLink to="/ba3a/ved/reqRegistr" name={t("Request register")} />
                <MyLink to="/ba3a/ved/orderProcess" name={t("Order processing")} />
                <MyLink to="/ba3a/ved/reqInProgress" name={t("Requests in progress")} />
                <MyLink to="/ba3a/ved/factorySettings" name={t("factory cc")} />
                <MyLink to="/ba3a/ved/vedSettingsGeneral" name={t("General VED settings")} />
                <MyLink to="/ba3a/ved/receiptAndVerific" name={t("rec and ver")} /> */}
              {/* </NavItem> */}
              {/* <NavItem name={t("LOGISTICIAN")} disabled></NavItem> */}
              {/* <NavItem name={t("FIN UNIT")} disabled> */}
              {/* <MyLink to="/ba3a/finance/fin-block/paymentsregistr" name={t("Payments register for Pf")} /> */}
              {/* </NavItem> */}
              {/* <NavItem name={t("FIN ACCOUNTING")} disabled> */}
              {/* <MyLink to="/ba3a/finance/fin-accounting" name={t("FIN ACCOUNTING")} />
                <MyLink to="/ba3a/finance/fin-accounting/accountsdir" name={t("Account handbook")} /> */}
              {/* </NavItem> */}
              {/* <NavItem name={t("SERVICE")} disabled></NavItem> */}

              {/* <NavItem name={t("WAREHOUSE")} disabled></NavItem> */}
              <NavItem name={t("SAMPLES")}>
                <MyLink to="/ba3a/warehouse/kits" name={t("kit reg")} />
                <MyLink to="/ba3a/warehouse/samples" name={t("sapmle reg")} />
                <ComplexTitle name={t("Transfer lists")}>
                  <MyLink to="/ba3a/warehouse/transferList/kits" name={t("kits")} className="pl" />
                  <MyLink to="/ba3a/warehouse/transferList/samples" name={t("samples")} className="pl" />
                </ComplexTitle>
                <ComplexTitle name={t("Settings")}>
                  <MyLink to="/ba3a/warehousesettings/guides" name={t("guides")} className="pl" />
                  <MyLink to="/ba3a/warehousesettings/deadlines" name={t("Deadlines")} className="pl" />
                  {/* {user?.role?.roleId === 3 && } */}
                  <MyLink to="/ba3a/warehousesettings/users" name={t("Users")} className="pl" />
                </ComplexTitle>
              </NavItem>
              <MyLink to="/ba3a/report" name={t("report")} />
              <NavItem name={t("HELP")}>
                <RouteLink to="appsettings/translate" name={t("Translation")} />
              </NavItem>

              <NavItem name={t("REFERENCE")} dataName={"ba3a/references"} disabled={!isITManager}>
                {isITManager ? <MyLink to="/ba3a/references/tasksList" name={t("Tasks list")} /> : <div></div>}
              </NavItem>
            </ul>
            <DevITButton />
          </nav>
        )}
        <div className="navbar__right">
          <div className="navbar__lang-switch" role="group" aria-label="Language">
            <span className={`navbar__lang-label ${!isUa ? "active" : ""}`}>ENG</span>
            <label className="navbar__lang-toggle">
              <input type="checkbox" checked={isUa} onChange={handleLangToggle} aria-label="Toggle language" />
              <span className="navbar__lang-slider" />
            </label>
            <span className={`navbar__lang-label ${isUa ? "active" : ""}`}>UA</span>
          </div>
          <div className="navbar__datetime">
            <div className="navbar__datetime_wrapper">
              <h1>
                <Moment format="DD.MM.YYYY" />
              </h1>
              <h1>
                <Moment format="HH:mm" interval={1000 * 60} />
              </h1>
            </div>
            {user && Object.prototype.hasOwnProperty.call(user, "email") && (
              <div className="user_label__container">
                <label htmlFor="" className="label user_label">
                  <span>
                    {user.firstName} {user.lastName}
                  </span>
                </label>
                <img
                  src={logoutPng}
                  alt=""
                  title={t("LogOut")}
                  onClick={() => {
                    dispatch(logout());
                  }}
                  draggable="false"
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const NavItem = props => {
  const [open, setOpen] = useState(false);

  return (
    <div
      className={`nav-item ${props.disabled ? "navItemDisabled" : ""}`}
      onClick={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
    >
      {props.name}
      {open && <div className="dropdown">{props.children}</div>}
    </div>
  );
};

const MyLink = props => {
  let activeStyle = {
    fontWeight: 600,
  };

  return (
    <div className="nav-item">
      <NavLink
        end
        to={props.to}
        style={({isActive}) => (isActive ? props.style || activeStyle : undefined)}
        className={props.className}
      >
        {props.name}
      </NavLink>
    </div>
  );
};

const RouteLink = props => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="nav-item">
      <span
        onClick={() => {
          navigate(`${location.pathname}/${props.to}`);
        }}
        style={props.style}
        className={props.className}
      >
        {props.name}
      </span>
    </div>
  );
};

const ComplexTitle = ({name, children}) => {
  const [open, setOpen] = useState(false);

  return (
    <div
      className="nav-item navHover"
      onClick={() => setOpen(prev => !prev)}
      style={{fontWeight: "400", cursor: "pointer"}}
    >
      <div className="row gap">
        {name}
        {open ? (
          <img alt="" src={ArrowUp} draggable="false" width="10px" />
        ) : (
          <img alt="" src={ArrowDown} draggable="false" width="10px" />
        )}
      </div>

      {open && (
        <div style={{fontSize: "1rem", lineHeight: "1.3rem"}} onClick={e => e.stopPropagation()}>
          {children}
        </div>
      )}
    </div>
  );
};

export default NavBar;
